// extracted by mini-css-extract-plugin
export default {"wrapper":"ToggleButton_wrapper__iAHsV","secondary":"ToggleButton_secondary__nfBc2","opened":"ToggleButton_opened__YFTAv","icon":"ToggleButton_icon__wUuRx"};